import { isObject } from '@vueuse/core';

import type { AnyObject } from '@/types';

export const convertObjKeys = <T extends AnyObject>(
  obj: T,
  convertKey: (str: string) => string,
) => {
  const entries = Object.entries(obj);

  const convertedKeys: [string, unknown][] = entries.map(([key, value]) => [
    convertKey(key),
    isObject(value) ? convertObjKeys(value as T, convertKey) : value,
  ]);

  return Object.fromEntries(convertedKeys);
};
